var map = {
	"./backlight1.jpg": 309,
	"./backlight10.jpg": 310,
	"./backlight11.jpg": 311,
	"./backlight12.png": 312,
	"./backlight2.jpg": 313,
	"./backlight3.jpg": 314,
	"./backlight4.jpg": 315,
	"./backlight5.jpg": 316,
	"./backlight6.jpg": 317,
	"./backlight7.jpg": 318,
	"./backlight8.jpg": 319,
	"./backlight9.jpg": 320,
	"./capa_backlight.jpg": 321
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 15
// module chunks = 0